import type { FC } from "react";
import type { IconProps } from "./types";

export const SpeechBubblePlus: FC<IconProps> = ({
  color = "var(--sinch-ref-color-main-snow-100)",
  height = 24,
}) => (
  <svg
    width="25"
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5 7.51861C20.5 6.13689 19.3791 5.01723 17.9974 5.0173C15.7225 5.01741 13.4102 5.01498 11.1075 5.01255C9.74266 5.01112 8.38114 5.00969 7.03273 5.00879C5.652 5.00787 4.53271 6.12718 4.53271 7.50791V15.526C4.53271 16.9067 5.65228 18.026 7.03299 18.026H7.27735V20.2416C7.27735 20.8494 7.9624 21.2048 8.45928 20.8547L12.4748 18.026H18.0011C19.3819 18.026 20.5 16.9067 20.5 15.526V7.51861ZM13.3915 8.47669C13.3915 7.99344 12.9997 7.60169 12.5165 7.60169C12.0332 7.60169 11.6415 7.99344 11.6415 8.47669V10.5613H9.55676C9.07351 10.5613 8.68176 10.9531 8.68176 11.4363C8.68176 11.9196 9.07351 12.3113 9.55676 12.3113H11.6415V14.3959C11.6415 14.8792 12.0332 15.2709 12.5165 15.2709C12.9997 15.2709 13.3915 14.8792 13.3915 14.3959V12.3113H15.476C15.9593 12.3113 16.351 11.9196 16.351 11.4363C16.351 10.9531 15.9593 10.5613 15.476 10.5613H13.3915V8.47669Z"
      fill={color}
    />
  </svg>
);
